import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {userActions} from '../../../actions/index';
import StyledEmailSubcriptionCTAFlower from "./EmailSubcriptionCTAFlower.styled";
import {connect} from "react-redux";

const EmailSubcriptionCTAFlower = props => {
   const {dispatch, message} = props;
   const input = useRef();
   const handleSubscribe = e  => {
        e.preventDefault();
        const { email } = e.target;
        const formData = {
            email: email.value.trim()
        };
        return dispatch(userActions.subscribeEmailFooter(formData));
   };
    useEffect(() => {
        if(message && message === 'Success'){
            input.current.value='';
        }
    }, [message]);
  return (
    <StyledEmailSubcriptionCTAFlower>
      <h3 className="email-sub__heading t-shelf-heading-flower">Join the House Party</h3>
      <p className="email-sub__copy t-description-flower-light">Sign up for the latest deals, new arrivals, and fresh drops.</p>
      <form className="email-sub__form"  onSubmit={handleSubscribe} >
        <label className="t-hidden" htmlFor="subEmail">Enter your email address</label>
        <input className="t-description-flower-light email-sub__input" id="subEmail" name="email" type="email" required placeholder="EMAIL ADDRESS" ref={input} />
        <button type="submit" className="t-description-flower-light email-sub__button">SIGN UP</button>
      </form>
    </StyledEmailSubcriptionCTAFlower>
  );
};

const mapStateToProps = ({alert}) => ({
    message: alert.message
});

EmailSubcriptionCTAFlower.propTypes = {
  message: PropTypes.string,
};

export default connect(mapStateToProps)(EmailSubcriptionCTAFlower);
